// NO LONGER USE, DEPRECATED FUNCTIONS

export function convertToObject(array = [], fieldValue, field) {
return array.reduce((acum, item) => {
    item[field].forEach((key) => {
      acum[key] = item[fieldValue];
    });
    return acum;
  }, {});
}

export function convertToObjectByField(array = [], fieldValue, field) {
  return array.reduce((acum, item) => {
    acum[item[field]] = item[fieldValue];
    return acum;
  }, {});
}

export const convertToObjById = (data, key = null) => {
  try {
    return data?.reduce((acc, curr) => {
      key ? (acc[curr[key]] = curr) : (acc[curr.id] = curr);
      return acc;
    }, {});
  } catch (error) {
    console.log(error);
  }
};

export const toArray = (data) => {
  if (typeof data !== "object" || data === null) {
    throw new Error("Invalid input: data must be a non-null object.");
  }

  return Object.keys(data).map((id) => {
    const value = data[id];

    if (value === undefined || value === null) {
      console.warn(`Warning: The value for key "${id}" is ${value}`);
    }

    return value;
  });
};

export const toObject = (data) => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid input: data must be an array.");
  }

  return data.reduce((acc, curr) => {
    if (typeof curr !== "object" || curr === null) {
      throw new Error(
        "Invalid data entry: each item in the array must be an object."
      );
    }

    const key = curr.id || curr.id_unit;
    if (!key) {
      throw new Error(
        "Missing identifier: each item must have either 'id' or 'id_unit'."
      );
    }

    acc[key] = curr;
    return acc;
  }, {});
};
